import { CartActions, CartAPI } from '@theme/cart-api';
import { installCartCacheGlobals, CartCache } from "@theme/cart-cache";
import { CartStore } from '@theme/cart-store';
import {
  bindUI,
  dispatchCartEvents,
  initCart,
  updateCartCounters,
  updateCartDrawer,
  updateQuickAddButtons,
} from '@theme/cart-ui';

installCartCacheGlobals();

import { syncCartVariantUi } from '@theme/cart-variant-sync';

function setupCartSubscriptions() {
  CartStore.subscribe((state) => {
    const cart = state.cart;
    if (!cart) return;

    updateCartCounters(cart);
    updateCartDrawer().catch(() => {});

    syncCartVariantUi(state);
    updateQuickAddButtons(state);
  });

  CartStore.subscribe((state) => {
    if (!state.cart) return;
    const isCartPage = window.location.pathname === '/cart' || document.querySelector('cart-items-component');
    if (!isCartPage) {
      dispatchCartEvents(state.cart);
    }
  });
}

function setupCartObservers() {
  let observerBindTimer = null;

  const observer = new MutationObserver((mutations) => {
    let shouldBind = false;
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1 || !(node instanceof Element)) return;
        const element = node;
        if (element.matches?.('[data-quick-add-button], [data-buy], [data-product-form], [data-counter], [data-mobile-bar]')) {
          shouldBind = true;
          return;
        }
        if (element.querySelector?.('[data-quick-add-button], [data-buy], [data-product-form], [data-counter], [data-mobile-bar]')) {
          shouldBind = true;
        }
      });
    });
    if (!shouldBind) return;
    if (observerBindTimer) clearTimeout(observerBindTimer);
    observerBindTimer = setTimeout(() => {
      observerBindTimer = null;
      bindUI(document);
    }, 80);
  });

  const target = document.body;
  if (target) {
    observer.observe(target, { childList: true, subtree: true });
  }
}

function bootCartController() {
  setupCartSubscriptions();
  initCart();

  document.addEventListener('shopify:section:load', (e) => {
    initCart(e.target);
  });

  document.addEventListener('filter:update', () => {
    setTimeout(() => bindUI(document), 100);
  });

  if (document.body) {
    setupCartObservers();
  } else {
    document.addEventListener('DOMContentLoaded', setupCartObservers);
  }
}

window.addEventListener('pageshow', (event) => {
  if (!event.persisted) return;
  CartCache.invalidate();
  CartAPI.fetch()
    .then((cart) => CartStore.set(cart))
    .catch((error) => console.error('Failed to refresh cart after page restore:', error));
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootCartController);
} else {
  bootCartController();
}

window.CartActions = CartActions;
